/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

// 发起挑战 http://wiki.xunlei.cn/pages/viewpage.action?pageId=122811692
export const start_prize_challenge = createAsyncThunk(
  'BigAward/start_prize_challenge',
  async (p: any, store: any) => {
    const resp = await http.post('/live/activity/start_prize_challenge', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)
// 获取活动基础数据 http://wiki.xunlei.cn/pages/viewpage.action?pageId=90612311
export const get_activity_info = createAsyncThunk(
  'BigAward/start_prize_challenge',
  async (p: any, store: any) => {
    const resp = await http.post('/live/commonactivity/get_activity_info', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)
// 大奖挑战赛详情接口 http://wiki.xunlei.cn/pages/viewpage.action?pageId=122811674
export const union_challenge_stage = createAsyncThunk(
  'BigAward/union_challenge_stage',
  async (params, store: any) => {
    const resp = await http.post('/live/activity/union_challenge_stage', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data?.data
  }
)

export async function getJobDonereward(params: {
  job_system_id: number
  job_id: number
}) {
  const res = await http.post('/live/commonactivity/get_job_done_reward', {
    ...params,
    ...window.store.getState().env.deviceinfo,
  })
  return res.data.data
}

//	pk晋级情况  0活动未开始；1进行中；2已结束；
export enum PKSTATUS {
  unstart = 0,
  doing = 1,
  finish = 2,
}
// 大奖挑战赛状态 0活动未开始；1可以发起挑战；2有进行中的挑战；3非公会主无法发起；4未晋级
export enum BIGAWARDSTATUS {
  unstart = 0,
  chanllenge = 1,
  chanlling = 2,
  ununion = 3,
  nochance = 4,
}
// 当前所处阶段：1PK晋级阶段 2大奖挑战赛阶段
export enum STAGESTATUS {
  pk = 1,
  bigaward = 2,
}

export interface CHANLLENGEITEM {
  level: number
  target: number
  icon: string
  rewards: {
    id: number
    icon: string
    desc: string
  }[]
  progress: number
  remaining_secs: number
  winner_show: {
    union_id: number
    avatar: string
    name: string
  }
  remaining_chances: number
  my_union_remaining_chances: number
  status: number
  union_success: number
  union_success_limit: number
}

export enum ROLETYPE {
  unioner = 1,
  anchor = 2,
}

const initialState: {
  stage: STAGESTATUS
  done: boolean
  role: ROLETYPE
  qualifying_round: {
    status: PKSTATUS
  }
  prize_challenge: {
    status: BIGAWARDSTATUS
    challenges: CHANLLENGEITEM[]
    ongoing_challenge?: CHANLLENGEITEM
  }
} = {
  stage: 1,
  done: false,
  role: ROLETYPE.anchor,
  qualifying_round: null,
  prize_challenge: null,
}

export const BigAwardSlice = createSlice({
  name: 'BigAward',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(union_challenge_stage.fulfilled, (state, action) => {
      Object.assign(state, {...action.payload, done: true})
    })
  },
})

export default BigAwardSlice.reducer
